if (!customElements.get('c-cart-announcement-slider')) {
  class CCartAnnouncementSlider extends HTMLElement {
    constructor() {
      super();
      this.track = this.querySelector('.c-announcement-notice-slider__track');
      this.slides = this.track ? this.track.children : [];
      this.currentIndex = 0;
      this.isPaused = false;
      this.delay = parseInt(this.dataset.slideDelay || '4000', 10);
      this.timeout = null;
    }

    connectedCallback() {
      if (!this.track || this.slides.length <= 1) return;

      this.addEventListener('mouseenter', () => {
        this.isPaused = true;
      });

      this.addEventListener('mouseleave', () => {
        this.isPaused = false;
      });

      this.start();
    }

    disconnectedCallback() {
      if (this.timeout) clearTimeout(this.timeout);
    }

    start() {
      const next = () => {
        if (!this.isPaused) {
          this.currentIndex = (this.currentIndex + 1) % this.slides.length;
          const nextSlide = this.slides[this.currentIndex];
          this.track.scrollTo({
            left: nextSlide.offsetLeft,
            behavior: 'smooth'
          });
        }

        this.timeout = setTimeout(next, this.delay);
      };

      this.timeout = setTimeout(next, this.delay);
    }
  }

  customElements.define('c-cart-announcement-slider', CCartAnnouncementSlider);
}

function updateIconsWithTextWrappedState(root = document) {
  const sections = root.querySelectorAll('.cc-icons-with-text');

  sections.forEach((section) => {
    const items = section.querySelectorAll('.slider__item, .c-icons-with-text-slide');

    items.forEach((item) => {
      const text = item.querySelector('.icons-with-text__text');
      if (!text) return;

      const title = text.querySelector('.icons-with-text__title');
      const body = text.querySelector('.rte');
      let isWrapped = false;

      if (title) {
        const titleStyles = window.getComputedStyle(title);
        const titleLineHeight = parseFloat(titleStyles.lineHeight);
        if (titleLineHeight && title.offsetHeight > titleLineHeight * 1.4) {
          isWrapped = true;
        }
      }

      if (!isWrapped && body) {
        const bodyStyles = window.getComputedStyle(body);
        const bodyLineHeight = parseFloat(bodyStyles.lineHeight);
        if (bodyLineHeight && body.offsetHeight > bodyLineHeight * 1.4) {
          isWrapped = true;
        }
      }

      item.classList.toggle('icons-with-text-item--wrapped', isWrapped);
    });
  });
}

window.addEventListener('load', () => updateIconsWithTextWrappedState());
window.addEventListener('resize', () => updateIconsWithTextWrappedState());
document.addEventListener('shopify:section:load', (event) => updateIconsWithTextWrappedState(event.target));
document.addEventListener('shopify:section:select', (event) => updateIconsWithTextWrappedState(event.target));